import { render, staticRenderFns } from "./headerLesson.vue?vue&type=template&id=22082719&"
import script from "./headerLesson.vue?vue&type=script&lang=js&"
export * from "./headerLesson.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports